import React from "react";
import { Link } from "react-router-dom";
import "../styles/Products.css";


const Products: React.FC = () => {
  return (
    <div className="product">Coming Soon....</div>
  );
};

export default Products;
